import { useEffect } from 'react';

interface UseIndividualCalendarLayoutEffectsProps {
  calendarDataRefreshKey: number;
  centerNode: HTMLDivElement | null;
  loadIndividualJournalHandler(): Promise<void>;
  updateAvailableGridWidth(value: number): void;
}

export const useIndividualCalendarLayoutEffects = ({
  calendarDataRefreshKey,
  centerNode,
  loadIndividualJournalHandler,
  updateAvailableGridWidth,
}: UseIndividualCalendarLayoutEffectsProps) => {
  useEffect(() => {
    void loadIndividualJournalHandler();
  }, [calendarDataRefreshKey, loadIndividualJournalHandler]);

  useEffect(() => {
    if (!centerNode) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      updateAvailableGridWidth(entry.contentRect.width);
    });

    observer.observe(centerNode);
    updateAvailableGridWidth(centerNode.clientWidth);

    return () => {
      observer.disconnect();
    };
  }, [centerNode, updateAvailableGridWidth]);
};
